import styled from "styled-components";
import { useEffect, useState } from "react";
import axios from "../../axios";

const Card = styled.div`
  background-color: #e0ffe0;
  padding: 16px 24px;
  border-radius: 16px;
  margin-bottom: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
`;

const Title = styled.h3`
  font-size: 18px;
  text-align: center;
`;

export default function LastStudentCard() {
  const [student, setStudent] = useState(null);

  useEffect(() => {
    const fetchLastStudent = async () => {
      try {
        const res = await axios.get(`students/all`);
        const sorted = res.data
          .filter(({ studentId }) => studentId !== "228" && studentId !== "288")
          .sort((a, b) => Number(a.studentId) - Number(b.studentId));

        const last = sorted[sorted.length - 1];

        if (last) {
          setStudent(last);
        }
      } catch (err) {
        console.error("Помилка при отриманні останнього учня:", err);
      }
    };

    fetchLastStudent();
  }, []);

  if (!student) return null;

  return (
    <Card>
      <Title>
        Останній доданий учень - {student.name} ({student.studentId})
      </Title>
    </Card>
  );
}
